import { useState } from 'react';
import { Popover } from '@material-ui/core';

interface ExpandableTextCellProps {
  text: any; // Se acepta 'any' para sanitizar posibles JSX o nulos pasados por la tabla
  maxWidthClass?: string;
  labelMobile?: string;
  isMobileOrTablet?: boolean;
}

export const ExpandableTextCell = ({
  text,
  maxWidthClass = 'w-48',
  labelMobile,
  isMobileOrTablet
}: ExpandableTextCellProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  // 1. Sanitización del valor recibido
  let stringValue = '';
  if (typeof text === 'string') {
    stringValue = text;
  } else if (text !== null && text !== undefined) {
    stringValue = String(text);
  }

  const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl((prev) => (prev ? null : e.currentTarget));
  };

  const handleClose = () => setAnchorEl(null);

  // Si no hay texto renderiza el guión por defecto sin romper la celda
  if (!stringValue.trim()) {
    return <span className="text-xs text-gray-400">-</span>;
  }

  return (
    <div
      className={`flex items-center justify-between text-sm relative ${maxWidthClass}`}
      onClick={(e) => e.stopPropagation()}
    >
      {isMobileOrTablet && labelMobile ? (
        <span className="font-semibold text-xs mr-2">{labelMobile}</span>
      ) : null}

      <div className="flex items-center gap-1.5 w-full min-w-0 text-gray-700 dark:text-ink-dark">
        {/* Texto con ancho forzado y truncado explicito */}
        <span className="text-xs truncate flex-1 block">
          {stringValue}
        </span>

        {/* Botón de despliegue */}
        <button
          type="button"
          onClick={handleToggle}
          className="p-1 rounded-full text-inkMuted hover:text-black dark:text-inkMuted-dark dark:hover:text-white transition-colors flex-shrink-0"
          title="Ver detalle completo"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
        </button>
      </div>

      {/* Popover de MUI: hereda el mismo fondo/color (light y dark) que el resto de los
          Dialog/Popover de la app vía el theme, anclado debajo-izquierda del botón, igual
          que la posición del popover anterior. */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        elevation={3}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ className: 'rounded-md' }}
      >
        <div
          className="text-xs p-3 max-w-sm w-80 whitespace-pre-line break-words leading-relaxed"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center mb-2 pb-1 border-b border-gray-100 dark:border-white/10">
            <span className="font-bold text-[10px] uppercase tracking-wider opacity-60">
              Detalle
            </span>
            <button
              type="button"
              onClick={handleClose}
              className="opacity-50 hover:opacity-100 transition-opacity text-xs font-bold px-1"
            >
              ✕
            </button>
          </div>
          {stringValue}
        </div>
      </Popover>
    </div>
  );
};

export default ExpandableTextCell;